import { KeyFact } from '../types';

interface Props {
  facts: KeyFact[];
  onFactClick?: (fact: KeyFact) => void;
}

export default function KeyFactCards({ facts, onFactClick }: Props) {
  if (!facts || facts.length === 0) return null;
  return (
    <ul className="flex flex-wrap gap-2">
      {facts.map((f, i) => {
        const clickable = !!f.source_node_id && !!onFactClick;
        return (
          <li
            key={`${f.label}-${i}`}
            className={`flex flex-col gap-0.5 px-3 py-2 rounded-lg border border-neutral-200 bg-neutral-50 min-w-[120px] ${
              clickable ? 'cursor-pointer hover:border-primary-300 hover:bg-primary-50 transition-colors' : ''
            }`}
            onClick={clickable ? () => onFactClick!(f) : undefined}
            role={clickable ? 'button' : undefined}
            tabIndex={clickable ? 0 : undefined}
            onKeyDown={
              clickable
                ? (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      onFactClick!(f);
                    }
                  }
                : undefined
            }
          >
            <span className="text-[10px] font-semibold uppercase tracking-wide text-neutral-500">
              {f.label}
            </span>
            <span className="text-sm font-semibold text-neutral-900">{f.value}</span>
          </li>
        );
      })}
    </ul>
  );
}
